// Support.js
//
//  Updated 3/1.
//
//  Abstract: Support page component.

//	React
import React, { useState, useEffect } from 'react';
//	Hooks
import useFetch from '../../hooks/useFetch.js';
//  Components
import CardTemplate from '../__common__/CardTemplate/CardTemplate.js';
import PhoneInput from 'react-phone-input-2';
//	Material-ui styles
import {
    makeStyles,
    Typography,
    Grid,
    Button,
    CircularProgress,
    Link,
    TextField
} from '@material-ui/core';
import 'react-phone-input-2/lib/style.css';

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%',
        marginTop: theme.spacing(3)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    progess: {
        position: 'absolute'
    },
    logos: {
        width: '125px',
    },
    gridItem: {
        textAlign: 'center'
    }
}));

export default function Register(props) {

    //	CSS classes
    const classes = useStyles();
    const { post } = useFetch();

    //	Set state
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    //	Event handlers
    function handleSubjectChange(event) {
        setSubject(event.target.value);
    }
    function handleBodyChange(event) {
        setBody(event.target.value);
    }
    function handleEmailChange(event) {
        setEmail(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);
        const supportRequest = {
            subject: subject,
            body: body,
            email: email,
            phoneNumber: phoneNumber,
        };
        post('/ticket', supportRequest)
            .then((data) => {
                setIsLoading(false);
                if (data) {
                    setIsSubmitSuccess(true);
                } else {
                    // Response error
                    setErrors(data);
                    console.log(data);
                    setIsLoading(false);
                }
            })
            .catch((errors) => {
                // Network error
                setErrors(errors);
                setIsLoading(false);
            });
    }
    return (
        <>
            <CardTemplate cardMaxWidth={'sm'}>
                <form className={classes.form} noValidate>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        spacing={2}>
                        <Grid item >
                            <Typography variant="p">
                                Please complete the support request form and we'll be in touch soon.
                        </Typography>
                        </Grid>
                        <Grid item sm={12} xs={6} >
                            <TextField
                                variant="outlined"
                                color="secondary"
                                required
                                fullWidth
                                id="subject"
                                label="Request Subject"
                                name="subject"
                                autoComplete="subject"
                                helperText={errors.subject}
                                error={errors.subject ? true : false}
                                onChange={handleSubjectChange}
                            />
                        </Grid>
                        <Grid item sm={12} xs={6} >
                            <TextField
                                variant="outlined"
                                color="secondary"
                                required
                                fullWidth
                                id="body"
                                label="What would you like assistance with?"
                                name="body"
                                autoComplete="body"
                                helperText={errors.body}
                                rows={6}
                                error={errors.body ? true : false}
                                multiline={true}
                                onChange={handleBodyChange}
                            />
                        </Grid>
                        <Grid item sm={12} xs={6} >
                            <TextField
                                color="secondary"
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                helperText={errors.email}
                                error={errors.email ? true : false}
                                onChange={handleEmailChange}
                            />
                        </Grid>
                        <Grid item container spacing={2} direction='row' justify="flex-start">
                            <Grid item sm={8} xs={6} >

                                <PhoneInput
                                    country={'us'}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                    }}
                                    value={phoneNumber}
                                    onChange={phoneNumber => setPhoneNumber(phoneNumber)}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item className={classes.gridItem} >
                    {/* <Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
						disableElevation
						onClick={handleSubmit}
						disabled={isLoading ||
							!title ||
							!email ||
							!password ||
							!firstName ||
							!lastName ||
							!organization
						}
					>
						Register
						{isLoading && <CircularProgress size={30} className={classes.progess} />}
					</Button>
                     */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disableElevation
                            color="tertiary"
                            className={classes.submit}
                            onClick={handleSubmit}
                            disabled={isLoading ||
                                !subject ||
                                !body ||
                                !email ||
                                !phoneNumber
                            }
                        >
                            Submit
						{isLoading && <CircularProgress size={30} className={classes.progess} />}
                        </Button>
                    </Grid>
                    <Grid item className={classes.gridItem} >
                        <Link href="/login" variant="body2" color="secondary">
                            {"Return to Login"}
                        </Link>
                    </Grid>
                </form>

            </CardTemplate>
        </>
    );
}